import { AttributeObserver } from '@hotwired/stimulus'
import type { ControllerModule } from './helpers'
import {
  CONTROLLER_ATTRIBUTE,
  extractControllerNamesFrom,
  pendingControllerCount,
} from './helpers'

export type ControllerResolver = (
  name: string
) => Promise<ControllerModule | void> | void

export function initializeControllerLoader(resolve: ControllerResolver) {
  const loadForElement = (element: Element) => {
    for (const name of new Set(extractControllerNamesFrom(element))) {
      // An importer can fail (for example after a deploy). Keep the observer alive.
      try {
        Promise.resolve(resolve(name)).catch((error) => {
          console.error(`Could not load Stimulus controller ${name}`, error)
        })
      } catch (error) {
        console.error(`Could not load Stimulus controller ${name}`, error)
      }
    }
  }

  const root = document.documentElement
  const observer = new AttributeObserver(root, CONTROLLER_ATTRIBUTE, {
    elementMatchedAttribute: loadForElement,
    elementAttributeValueChanged: loadForElement,
  })
  // start() also matches the root and existing descendants synchronously.
  observer.start()

  if (import.meta.env.DEV) {
    Object.defineProperty(window, 'StimulusLazyLoadCounter', {
      configurable: true,
      get: pendingControllerCount,
    })
  }
}
